module.exports = __webpack_public_path__ + "static/media/credit_card.0bf1ebd6.svg";